import { useState } from "react";
import Drawer from "../Drawer";
import "./LoginHeader.scss";

export default function LoginHeader() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };
  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };
  return (
    <div className="header-section">
      <div className="logo"></div>
      <div className="right-side">
        {/* <div className="need-help">Need help?</div> */}

        <div className="contact-us">
          <button onClick={openDrawer} className="btn">
            Contact us
          </button>
        </div>
        <Drawer isOpen={isDrawerOpen} onClose={closeDrawer} />
      </div>
    </div>
  );
}
